export const NAME = 'name';
export const EMAIL = 'email';
export const PERMISSIONS = 'permissions';
export const IS_TEST = 'isTest';
